import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Pagination,
} from "@mui/material"
import {
    StyledTableCell,
    StyledTableRow,
} from "components/tables/StyledTable.tsx"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { ListInvoiceInfo, InvoiceInfo } from "types/list-invoice"
import { OreveButton } from "components/button/OreveButton.tsx"
import DownloadIcon from "@mui/icons-material/Download"
import { invoicesColumns } from "layouts/invoices/utils/const"
import { InvoiceHeaderCell } from "layouts/invoices/table/cells"
import {
    InvoicesTableColumnsType,
    columnsInvoiceOrder,
} from "layouts/invoices/utils/types"
import { SortOrder } from "types/sort"

export const InvoiceTable = ({
    rows,
    sortOrder,
    orderBy,
    setSortOrder,
    setOrderBy,
}: {
    rows: ListInvoiceInfo
    sortOrder: SortOrder
    orderBy: keyof InvoicesTableColumnsType
    setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>
    setOrderBy: React.Dispatch<
        React.SetStateAction<keyof InvoicesTableColumnsType>
    >
}) => {
    const [pageNumber, setPageNumber] = useState(1)
    const [numberOfPages, setNumberOfPages] = useState(0)
    const rowsPerPage = 10

    useEffect(() => {
        setNumberOfPages(Math.ceil(rows.length / rowsPerPage))
        setPageNumber(1)
    }, [rows.length])

    const currentSessionsRows = useMemo(() => {
        return rows.slice(
            rowsPerPage * (pageNumber - 1),
            rowsPerPage * pageNumber
        )
    }, [rows, pageNumber])

    const handleChangePage = useCallback(
        (_event: React.ChangeEvent<unknown>, page: number) => {
            setPageNumber(page)
        },
        []
    )

    return (
        <>
            <TableContainer sx={{ borderRadius: "10px 10px 0 0" }}>
                <Table sx={{ border: 0 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {columnsInvoiceOrder.map((col) => {
                                return (
                                    <InvoiceHeaderCell
                                        key={col}
                                        keyInvoice={col}
                                        title={invoicesColumns[col].title}
                                        unsortable={false}
                                        width={invoicesColumns[col].width}
                                        sortOrder={sortOrder}
                                        orderBy={orderBy}
                                        setSortOrder={setSortOrder}
                                        setOrderBy={setOrderBy}
                                    />
                                )
                            })}
                            <StyledTableCell sx={{ width: "16%" }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {currentSessionsRows.map((invoice: InvoiceInfo) => (
                            <StyledTableRow key={invoice.id}>
                                {columnsInvoiceOrder.map((col) => {
                                    const CellComponent =
                                        invoicesColumns[col].cellComponent
                                    return (
                                        <StyledTableCell key={col}>
                                            <CellComponent invoice={invoice} />
                                        </StyledTableCell>
                                    )
                                })}
                                <StyledTableCell key="dlbutton">
                                    <OreveButton
                                        icon={DownloadIcon}
                                        value={"Télécharger"}
                                        variant={"text"}
                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                color="primary"
                count={numberOfPages}
                page={pageNumber}
                onChange={handleChangePage}
                sx={{
                    mx: "auto",
                }}
            />
        </>
    )
}
